module.exports = __webpack_public_path__ + "img/company5.270ba110.png";